<template>
  <div class="main-wrapper">
    <div class="table">
      <div class="background-content"></div>
      <div class="table__title">{{ data?.title }}</div>
      <!-- <div class="container-list"> -->
      <div class="container-list">
        <span class="unit">{{ data?.unit }}</span>
        <div class="table__list">
          <div class="list" v-for="(item, index) in data?.data" :key="index">
            <span class="list__number">{{ index + 1 }}</span>
            <span class="list__country">{{ item.country }}</span>
            <span class="list__value">{{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="news">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url },
          })
        "
        class="card"
        :class="`card-${index + 1}`"
        v-for="(item, index) in list"
        :key="item.id"
      >
        <div class="card__img">
          <ImageContainer
            class="img"
            :src="item.image.medium"
            :thumb="item.image.thumbnail"
            :alt="item.title"
          />
        </div>
        <div class="card__content">
          <div class="opacity-content"></div>
          <div class="card__category">
            <div>{{ item.sub_category.name }}</div>
          </div>
          <div class="card__title">
            <h3 class="limited-text">
              {{ item.title }}
            </h3>
          </div>
          <div class="data-news">
            <span class="day">{{ handleDate(item.pub_date) }},</span>
            <span class="time">{{ handleTime(item.pub_date) }}</span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import ImageContainer from "@/components/ImageContainer";
import { useFormatter } from "@/utils/formatter";
import { ref } from "vue";
import { useLanguage } from "@/utils/language";

export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const data = ref();
    const { i18n } = useLanguage();

    const table = [
      "charity",
      "happiness",
      "oil",
      "population",
      "power",
      "production",
    ];

    const loadStat = async (folder) => {
      import(
        `@/components/society/stats/${folder}/${i18n.global.locale.value}.json`
      ).then((res) => {
        data.value = res;
      });
    };

    loadStat(table[Math.floor(Math.random() * table.length)]);

    // onMounted(async () => {
    //   try {
    //   } catch (error) {
    //     console.log(error);
    //   }
    // });

    return {
      data,
      ...useFormatter(),
    };
  },
};
</script>

<style lang="scss" scoped>
.main-wrapper {
  padding-top: calc(max(150px, 10vw));
  width: 100%;
  // min-height: 70vh;
  height: min-content;
  display: grid;
  grid-template-columns: 1fr 3fr;
  background: linear-gradient(180deg, #1d2b64 0%, #f8cdda 153.43%);
  gap: 0 2em;
}

.table {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: auto;
  position: relative;
  height: 100%;
  .container-list {
    position: relative;
    margin-top: 2rem;
  }
  .unit {
    position: absolute;
    top: -18px;
    font-weight: 600;
    color: #fff;
    right: 15%;
    font-size: 0.88em;
    line-height: 16px;
    // width: 70px;
    text-align: center;

    color: rgba(255, 255, 255, 0.4);
  }

  .background-content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: linear-gradient(
      180deg,
      #3a4074 0%,
      rgba(59, 65, 117, 0.991353) 12.56%,
      rgba(62, 67, 118, 0.96449) 25.13%,
      rgba(67, 71, 121, 0.91834) 37.69%,
      rgba(75, 77, 125, 0.852589) 50.26%,
      rgba(84, 84, 130, 0.768225) 62.82%,
      rgba(96, 92, 136, 0.668116) 75.39%,
      rgba(108, 102, 143, 0.557309) 87.95%,
      rgba(122, 111, 150, 0.442691) 100.52%,
      rgba(134, 121, 157, 0.331884) 113.08%,
      rgba(146, 129, 163, 0.231775) 125.65%,
      rgba(155, 136, 168, 0.147411) 138.21%,
      rgba(163, 142, 172, 0.0816599) 150.78%,
      rgba(168, 146, 175, 0.03551) 163.34%,
      rgba(171, 148, 176, 0.0086472) 175.9%,
      rgba(172, 149, 177, 0) 188.47%
    );
    opacity: 0.7;
  }
  &__title {
    text-align: center;
    font-size: 1.5em;
    color: #fff;
    // margin-top: 1rem;
    padding: 0 1rem;
    width: 80%;
    margin: 0 auto;

    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__list {
    width: 85%;
    margin: 0 auto;
    height: 61vh;
    overflow-y: scroll;
    overflow-x: hidden;
    scroll-behavior: smooth;
    cursor: default;
    position: relative;
    margin-bottom: 1rem;

    &::-webkit-scrollbar {
      width: 8px;
      // height: 50px;
    }
    &::-webkit-scrollbar-thumb {
      background: #897b9e;
    }

    /* Track */
    &::-webkit-scrollbar-track {
      background: #5e5b87;
    }
  }
}
.list {
  padding: 0.5rem 0;
  display: flex;
  font-size: 1.125em;

  &:nth-child(even) {
    background: rgba(255, 255, 255, 0.05);
  }
  .list__number {
    text-align: center;
    width: 20%;
    color: #b9b9b9;
    font-size: 0.8em;
    line-height: 1.5em;
  }
  .list__country {
    flex-grow: 1;
    color: #c0c2dd;
  }
  .list__value {
    width: 30%;
    text-align: center;
    color: #ebebeb;
    font-weight: 600;
  }
}
.news {
  display: grid;
  grid-template-columns: 1fr 1fr;
  // grid-template-rows: repeat(4, minmax(160px, 9vw));
}
.card {
  position: relative;
  height: 100%;

  .data-news {
    text-align: right;
    position: relative;
    z-index: 1;
  }
  &__contetn {
    position: relative;
  }
  .opacity-content {
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    // width: 100%;
    // height: 100%;
    opacity: 0.7;
    background: linear-gradient(
      180deg,
      #3a4074 0%,
      rgba(59, 65, 117, 0.991353) 12.56%,
      rgba(62, 67, 118, 0.96449) 25.13%,
      rgba(67, 71, 121, 0.91834) 37.69%,
      rgba(75, 77, 125, 0.852589) 50.26%,
      rgba(84, 84, 130, 0.768225) 62.82%,
      rgba(96, 92, 136, 0.668116) 75.39%,
      rgba(108, 102, 143, 0.557309) 87.95%,
      rgba(122, 111, 150, 0.442691) 100.52%,
      rgba(134, 121, 157, 0.331884) 113.08%,
      rgba(146, 129, 163, 0.231775) 125.65%,
      rgba(155, 136, 168, 0.147411) 138.21%,
      rgba(163, 142, 172, 0.0816599) 150.78%,
      rgba(168, 146, 175, 0.03551) 163.34%,
      rgba(171, 148, 176, 0.0086472) 175.9%,
      rgba(172, 149, 177, 0) 188.47%
    );
  }
  &__title {
    position: relative;
    z-index: 1;
  }
  &__category {
    position: relative;
    z-index: 1;
  }
}

.card-1 {
  grid-column: 1;
  grid-row: span 2;
}
.card-4 {
  grid-column: 1;
  grid-row: span 2;
}
.card-2,
.card-3,
.card-5,
.card-6 {
  --offset-left: 18%;

  grid-column: 2;
  .card__img {
    position: absolute;
    left: 0;
    top: 15px;
    width: 8vw;
    min-width: 120px;
    .img {
      padding-bottom: 75%;
    }
  }
  .card__content {
    position: absolute;
    bottom: 0;
    left: var(--offset-left);
    z-index: 2;
    width: calc(100% - var(--offset-left));
    padding: 0.5em 1.8em 0;
  }
  .card__title {
    .limited-text {
      --snup: 2;
    }
  }
}

.card-1,
.card-4 {
  --offset-left: 35%;
  .card__content {
    position: absolute;
    bottom: 0;
    // transform: translateY(-50%);
    left: var(--offset-left);
    width: calc(95% - var(--offset-left));
    z-index: 2;
    padding: 1.5em 1em;
  }
  .card__title .limited-text {
    font-size: 1.3em;
  }

  .card__img {
    position: absolute;
    top: 0;
    left: 0;
    width: 16.5vw;
    min-width: 313px;
    .img {
      padding-bottom: 74%;
    }
  }
}
.card-1 {
  .card__content {
    bottom: 20px;
  }
}
.card-4 {
  .card__img {
    top: 25px;
  }
}
@media screen and (max-width: 1600px) {
  .table {
    &__title {
      width: 100%;
    }
    &__list {
      height: 60vh;
    }
  }
}
@media screen and (max-width: 1200px) {
  .main-wrapper {
    min-height: 70vh;
  }
  .card-1,
  .card-4 {
    --offset-left: 25%;
  }
  .card__title {
    .limited-text {
      // font-size: 1em !important;
    }
  }
}

@media screen and (max-width: 992px) {
  .main-wrapper {
    grid-template-columns: 1fr;
    padding: 6rem 1rem 0;
  }
  .news {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    margin-top: 2.5em;
    align-self: center;
  }
  .table {
    height: 400px;
    flex-direction: row;
    padding-top: 2rem;
    .container-list {
      flex: 1 0 50%;
      margin-top: 0;
    }
    .unit {
      top: 15px;
    }
    &__title {
      flex: 1 0 50%;
    }
    &__list {
      flex: 1;
      height: 95%;
      margin-top: auto;
    }
    .container-list {
      padding-top: 2rem;
      .unit {
        top: 10px;
      }
    }
  }
  .card-1,
  .card-2,
  .card-3,
  .card-4,
  .card-5,
  .card-6 {
    grid-column: 1;
    height: 175px;
    .card__img {
      width: 21%;
    }
  }

  .card-2,
  .card-3,
  .card-5,
  .card-6 {
    margin: 0.5rem 1.5rem;
  }
  .card-4,
  .card-1 {
    --offset-left: 30%;
    margin-top: 1rem;
    width: 100%;
    height: 350px;
    .card__img {
      width: 44%;
      max-width: 315px;
    }
    .card__content {
      top: 50%;
      width: calc(100% - var(--offset-left));
    }
  }
  .card-4 {
    grid-row: 7;
  }
}
@media screen and (max-width: 767px) {
  .main-wrapper {
    width: 100%;
    padding: 3.5rem 0 0;
  }
  .background-content {
    // bottom: -20px !important;
  }
  .table {
    height: 400px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.5rem;
    width: 95%;
    margin: 1rem auto 0;
    padding: 0;
    .container-list {
      height: 100%;
      width: 95%;
      margin: 0 auto;
      flex: 1 0 100%;
    }
    .unit {
      top: 15%;
      right: 10%;
    }
    &__title {
      flex: 1 0 15%;
      justify-self: center;
      align-self: center;
      margin-top: 0.5em;
      margin-left: auto;
      margin-right: auto;
    }
    &__list {
      flex: 1 0 85%;
      width: 100%;
      padding: 0 0.5rem;
      flex-grow: 0;
      height: 76%;
      margin-top: 0rem;
    }
  }
  .card-1,
  .card-4 {
    height: 400px;
    .card__img {
      position: relative;
      top: 10px;
      margin: 0 auto;
      z-index: 2;
      width: 80%;
    }
    .card__content {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 0;
    }
  }
  .card-4 {
    margin-top: 1rem;
  }
  .card-2,
  .card-3,
  .card-5,
  .card-6 {
    margin: 1rem 1rem;
    .card__img {
      width: 40%;
      max-width: 165px;
    }
    .card__content {
      bottom: 0%;
    }
  }
}
@media screen and (max-width: 320px) {
  .table .container-list {
    height: 85%;
    margin-top: auto;
  }
  .card-1,
  .card-4 {
    .card__content {
      top: -10px;
      // left: 0;
    }
  }
}

/* ----------- iPad Pro ----------- */
/* Portrait and Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (-webkit-min-device-pixel-ratio: 1.5) {
  .main-wrapper {
    // min-height: 50vw;
  }
  .card-4,
  .card-1 {
    --offset-left: 25%;
    .card__title {
      .limited-text {
        font-size: 18px !important;
      }
    }
  }
}

/* Portrait */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1.5) {
  .main-wrapper {
    min-height: 50vw;
    margin-bottom: 0rem;
  }
  .table {
    height: 70vw;
    &__list {
      height: 51vw;
    }
  }
}

/* Landscape */
@media only screen and (min-width: 1024px) and (max-height: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1.5) {
  .main-wrapper {
    min-height: 40vw;
    margin-bottom: 2rem;
  }
  .table {
    // height: 100%;
    &__list {
      height: 57vh;
    }
  }
  .card-4 {
    .card__content {
      padding-bottom: 0;
    }
  }
}
</style>
